interface MetadataProps {
  title?: string
}

export const Metadata: React.FC<MetadataProps> = ({ title }) => {
  return title && <title>{title}</title>
}
